module.exports = __webpack_public_path__ + "static/media/blive_rojo.39540d53.png";